var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Toolbox",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-toolbox","viewBox":"0 0 518 518"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M257.8 206.3c-17.4 0-31.5 14.1-31.5 31.5s14.1 31.5 31.5 31.5 31.5-14.1 31.5-31.5c0-17.3-14.1-31.5-31.5-31.5zm0 49c-9.6 0-17.5-7.9-17.5-17.5s7.9-17.5 17.5-17.5 17.5 7.9 17.5 17.5-7.8 17.5-17.5 17.5z"/>
  <path d="M378 136.7V84.4l-26.7-33.8h-183l-29 34.2v51.8H1V407h517V136.7H378zM165.3 94.4l15-17.8h158.3L352 93.5v43.2H165.3V94.4zM504 391.7H15V213h133v62.5l31.2 29.5h156.9l33.4-28.8.5-63.2h134v178.7zM356.1 199l-.5 70.8-24.7 21.2H184.8L162 269.5V199H15v-48.3h489V199H356.1z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/toolbox.svg